import { useMemo } from "react";
import { useParams } from "react-router";
import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { Separator } from "@/shared/components/ui/separator";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useQpmOfferShowQuery } from "@/services/backend/qpm/offers/api/offer-api";
import { OfferCertificatesAdditionalInfo } from "@/routes/processes/[processId]/qpm/offers/[offerId]/additional-info/_components/offer-certificates-additional-info";
import { CompanyReferences } from "@/routes/processes/[processId]/qpm/offers/[offerId]/additional-info/_components/company-references";

export function OfferAdditionalInfoRoute() {
  const params = useParams();
  const { offerId } = params;

  const {
    data: offer,
    isLoading,
    error,
  } = useQpmOfferShowQuery({ id: offerId! }, { skip: !offerId });

  const customerId = useMemo(
    () => offer?.customerId ?? "",
    [offer?.customerId],
  );

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (!offer) {
    return null;
  }

  return (
    <Card className="mb-12">
      <CardHeader className="py-4 font-bold">
        <div className="flex items-center justify-between">
          <CardTitle>{t("Zusatzinformationen")}</CardTitle>
        </div>
      </CardHeader>
      <div className="mx-6 mb-2">
        <Separator />
      </div>
      <CardContent>
        <div className="flex flex-col gap-8">
          <OfferCertificatesAdditionalInfo
            offerId={offerId!}
            customerId={customerId}
          />
          <CompanyReferences offerId={offerId!} />
        </div>
      </CardContent>
    </Card>
  );
}
